import colors from "../../base/colors"

const {error}=colors

export default {
    styleOverrides: {
      root: {
       color:error.main,
       textTransform:"capitalize"
      },
    }}